import React from 'react';
import './SystemWarning.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';

interface Params {
  children: any;
}

export const SystemWarning = (params: Params) => {
  return (
    <div className='system-warning'>
      <FontAwesomeIcon icon={faCircleExclamation} className='fe' />
      {params.children}
    </div>
  );
};
